import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';

const ToolCard = ({ 
  name, 
  color, 
  preview, 
  selected, 
  onClick, 
  gridItem = false
}) => {
  // Prepare box styles separately to avoid potential recursion
  const boxStyles = {
    display: 'block',
    width: 32,
    height: 32,
    borderRadius: 0.5,
    border: 1,
    borderColor: 'divider'
  };

  // Handle preview first, fall back to color if no preview
  if (preview) {
    if (typeof preview === 'string' && preview.startsWith('linear-gradient')) {
      boxStyles.background = preview;
    } else {
      boxStyles.backgroundImage = `url(${preview})`;
      boxStyles.backgroundSize = 'cover';
      boxStyles.backgroundPosition = 'center';
    }
  } else if (typeof color === 'string') {
    boxStyles.bgcolor = color;
  }

  return (
    <Card
      onClick={onClick}
      elevation={0}
      sx={{
        cursor: 'pointer',
        height: gridItem ? '100%' : 'auto',
        bgcolor: selected ? 'action.selected' : 'background.main',
        '&:hover': {
          bgcolor: 'action.hover'
        }
      }}
    >
      <CardContent
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 3,
          p: 2,
          '&:last-child': {
            pb: 2
          }
        }}
      >
        <Box
          component="span"
          sx={boxStyles}
        />
        <Typography 
          component="span"
          variant={'h5'} 
          fontWeight={600}
        >
          {name}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ToolCard; 